<header class="header active"
        [ngClass]="{
          'header-cst': isWhyHungeryClicked ,
          'header-login-cst': !isWhyHungeryClicked || isLogin
        }">
  <div class="overlay" (click)="removeOverlay()"></div>
  <nav class="navbar navbar-expand-xl navbar-light">
    <div class="container">
      <!-- <a *ngIf="isLogin" class="navbar-brand text-primary" href="#" title="Bliss">Bliss</a> -->
      <div *ngIf="isLogin" class="logo-dv"><a class="navbar-brand" routerLink="/" title="Hungery"> <img src="./assets/images/Hungery-Logo.svg" alt="Hungery" class="img-fluid img-logo" /> </a></div>
      <div *ngIf="!isLogin" class="logo-dv"><a class="navbar-brand" routerLink="/" title="Hungery"> <img src="./assets/images/Hungery-Logo.svg" alt="Hungery" class="img-fluid img-logo" /> </a></div>

      <div class="before-login-btns">
        <div class="btn-grps btn-only" *ngIf="!isLogin">

          <!-- [Start] Stop Click event for mobile applciation -->
          <app-button *ngIf="!isFromMobileApp" [id]="'register-btn'" [btnText]="'Register'" [btnTitle]="'Register'"
                      [btnCss]="'btn btn-text'"
                      (onBtnClick)="openRegisterFromHeader($event)"></app-button>
          <button *ngIf="isFromMobileApp" [id]="'register-btn'" class="btn btn-text" (click)="openRegisterFromHeader($event)">Register</button>
          <!-- Stop Click event for mobile applciation -->
          <!-- [Start] Stop Click event for mobile applciation -->
          <app-button *ngIf="!isFromMobileApp" [id]="'sign-in-btn'" [btnText]="'Sign In'" [btnTitle]="'Sign In'"
                      [btnCss]="'btn btn-primary'"
                      (onBtnClick)="openSignInFromHeader($event)"></app-button>
          <button *ngIf="isFromMobileApp" id="sign-in-btn" class="btn btn-primary" (click)="openSignInFromHeader($event)">Sign In</button>
          <!-- [End] Stop Click event for mobile applciation -->
        </div>
      </div>

      <app-button [btnText]="''" [btnTitle]="'Toggle navigation'" [btnCss]="'navbar-toggler'"
                  (onBtnClick)="toggleSidebar()">
        <img src="./assets/images/ic-menu-white.svg" alt="Icon">
      </app-button>

      <div class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
        <ul class="navbar-nav me-lg-auto">
          <li class="nav-item" *ngIf="!isWhyHungeryClicked || !isOnPricingOrWhyHungery">
            <a class="nav-link" aria-current="page" routerLink="/why-hungery" [routerLinkActiveOptions]="{ exact: true }"
               routerLinkActive="active" title="{{ 'Why Hungery' | translate }}" (click)="whyHungeryClick($event)">
              <div class="svg-wrap">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_4_3)">
                    <path d="M13.961 13.9972C12.0799 13.9972 10.2481 14.0056 8.41636 13.9933C7.61817 14.0157 6.81938 13.9843 6.02538 13.8994C4.25447 13.6437 2.64795 12.7188 1.5346 11.3141C0.421241 9.90934 -0.114763 8.13092 0.0362815 6.3428C0.198576 4.59423 1.01074 2.97088 2.31141 1.79526C3.61208 0.619644 5.30608 -0.0222076 7.05685 -0.00277259C8.80762 0.0166624 10.487 0.695961 11.7614 1.90017C13.0359 3.10437 13.812 4.74535 13.9357 6.4971C14.0659 8.9645 13.961 11.4444 13.961 13.9972ZM7.39681 8.36096C7.80945 7.80234 8.13746 7.34864 8.47742 6.90412C8.58692 6.78245 8.70299 6.66689 8.82511 6.55797C9.09556 6.29664 9.28364 5.96149 9.36606 5.59401C9.44847 5.22653 9.42161 4.84288 9.2888 4.49056C9.18432 4.15654 8.98136 3.86211 8.70669 3.6461C8.43202 3.4301 8.09853 3.30266 7.75019 3.28059C7.24895 3.21226 6.74052 3.21659 6.2405 3.29344C5.76264 3.36236 5.32908 3.61177 5.02846 3.99067C4.72785 4.36957 4.58289 4.84933 4.62323 5.33187H6.30178C6.32061 5.24951 6.33241 5.1784 6.35322 5.11007C6.4822 4.68664 6.74262 4.44913 7.20469 4.56207C7.29585 4.57973 7.38174 4.61823 7.45567 4.67456C7.52961 4.73089 7.58962 4.80355 7.63104 4.8869C7.67246 4.97024 7.69419 5.06204 7.69453 5.15517C7.69487 5.2483 7.67382 5.34025 7.63301 5.4239C7.4757 5.80328 7.23671 6.14308 6.93316 6.419C6.66571 6.65937 6.46219 6.96279 6.34099 7.30185C6.21979 7.6409 6.18473 8.00491 6.23898 8.36096H7.39681ZM6.94508 10.8102C7.06592 10.8193 7.18734 10.803 7.30148 10.7621C7.41561 10.7212 7.51993 10.6568 7.60767 10.5729C7.69542 10.4891 7.76464 10.3877 7.81087 10.2753C7.85709 10.163 7.87929 10.0421 7.87602 9.92063C7.87276 9.79912 7.8441 9.67964 7.79191 9.56994C7.73971 9.46024 7.66514 9.36274 7.57302 9.28376C7.4809 9.20478 7.37327 9.14607 7.25711 9.11143C7.14094 9.07679 7.01882 9.06699 6.89864 9.08267C6.78051 9.07732 6.66255 9.09638 6.55208 9.13866C6.4416 9.18095 6.34097 9.24556 6.25643 9.32849C6.17189 9.41141 6.10524 9.51088 6.06063 9.62072C6.01601 9.73055 5.99438 9.84842 5.99708 9.96699C6.00227 10.0854 6.03114 10.2016 6.08198 10.3086C6.13282 10.4156 6.20458 10.5113 6.29302 10.59C6.38145 10.6686 6.48474 10.7287 6.59675 10.7665C6.70877 10.8043 6.82722 10.8192 6.94508 10.8102Z" fill="currentcolor" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_3">
                      <rect width="14.0009" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {{ 'Why Hungery' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="!isWhyHungeryClicked || !isOnPricingOrWhyHungery">
            <a class="nav-link" aria-current="page" routerLink="/" [routerLinkActiveOptions]="{ exact: true }"
               routerLinkActive="active" title="{{ 'Dashboard' | translate }}" (click)="removeOverlay()">
              <div class="svg-wrap">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.4444 0H1.55556C0.697667 0 0 0.697667 0 1.55556V4.66667H14V1.55556C14 0.697667 13.3023 0 12.4444 0ZM0 12.4444C0 13.3023 0.697667 14 1.55556 14H7.77778V6.22222H0V12.4444ZM9.33333 14H12.4444C13.3023 14 14 13.3023 14 12.4444V6.22222H9.33333V14Z"
                        fill="currentcolor" />
                </svg>
              </div>
              {{ 'Dashboard' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="!isWhyHungeryClicked || !isOnPricingOrWhyHungery">
            <!-- [Start] Stop Click event for mobile applciation -->
            <a class="nav-link" id="restaurants-list-tab" routerLink="/listing" title="{{ 'Restaurants' | translate }}"
               routerLinkActive="active" (click)="removeOverlay()">
              <div class="svg-wrap">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1090_6155)">
                    <path d="M13.6358 11.9034L8.14611 6.41375L1.73236 0H1.23113L1.12878 0.260066C0.858649 0.946504 0.743231 1.64858 0.795047 2.29031C0.85411 3.02181 1.132 3.65512 1.59873 4.12185L6.60565 9.12877L7.26606 8.46836L11.8949 13.6443C12.3554 14.1048 13.148 14.1322 13.6358 13.6443C14.1158 13.1643 14.1158 12.3834 13.6358 11.9034Z"
                          fill="currentColor" />
                    <path d="M4.2855 7.96924L0.364103 11.8906C-0.115834 12.3706 -0.115834 13.1515 0.364103 13.6315C0.820033 14.0874 1.60876 14.1277 2.10494 13.6315L6.02637 9.71005L4.2855 7.96924Z"
                          fill="currentColor" />
                    <path d="M13.4054 2.33092L11.181 4.55534L10.6007 3.97505L12.8251 1.75061L12.2448 1.17032L10.0204 3.39473L9.44013 2.81444L11.6646 0.590027L11.0843 0.00976562L8.18287 2.91121C7.82792 3.26616 7.61598 3.73746 7.58601 4.23834C7.57843 4.36524 7.54967 4.49007 7.50195 4.60879L9.38673 6.49357C9.50546 6.4458 9.63031 6.41706 9.75718 6.40949C10.2581 6.3796 10.7294 6.1676 11.0843 5.81266L13.9858 2.91124L13.4054 2.33092Z"
                          fill="currentColor" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1090_6155">
                      <rect width="14" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {{ 'Restaurants' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="!isWhyHungeryClicked || !isOnPricingOrWhyHungery">
            <a class="nav-link"
               href="#"
               title="{{ 'Team' | translate }}"
               (click)="removeOverlay(false, true)"
               routerLinkActive="active"
               [ngbTooltip]="'Coming soon'"
               [tooltipClass]="'tooltip-custom'"
               placement="bottom"
               [attr.disabled]="true">
              <div class="svg-wrap">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0ZM7 12.6C3.9123 12.6 1.4 10.0877 1.4 7C1.4 6.1824 1.5806 5.4075 1.8963 4.7068C2.0041 4.7698 2.1119 4.8342 2.2155 4.9C2.4927 5.075 2.7692 5.25 3.1157 5.3816C3.4615 5.5125 3.8773 5.6 4.431 5.6C4.9854 5.6 5.4012 5.5125 5.7477 5.3809C6.0942 5.2493 6.3714 5.075 6.6486 4.9C6.9258 4.725 7.203 4.55 7.5495 4.4184C7.8953 4.2875 8.3111 4.2 8.8655 4.2C9.4199 4.2 9.8357 4.2875 10.1815 4.4191C10.528 4.55 10.8052 4.725 11.0824 4.9C11.3596 5.075 11.6368 5.25 11.9833 5.3816C12.1079 5.4285 12.2451 5.467 12.39 5.5013C12.5237 5.9787 12.6 6.4799 12.6 7C12.6 10.0877 10.0877 12.6 7 12.6Z"
                        fill="currentcolor" />
                  <path d="M4.55 8.40078C5.1299 8.40078 5.6 7.93068 5.6 7.35078C5.6 6.77088 5.1299 6.30078 4.55 6.30078C3.9701 6.30078 3.5 6.77088 3.5 7.35078C3.5 7.93068 3.9701 8.40078 4.55 8.40078Z"
                        fill="currentcolor" />
                  <path d="M9.45039 8.40078C10.0303 8.40078 10.5004 7.93068 10.5004 7.35078C10.5004 6.77088 10.0303 6.30078 9.45039 6.30078C8.87049 6.30078 8.40039 6.77088 8.40039 7.35078C8.40039 7.93068 8.87049 8.40078 9.45039 8.40078Z"
                        fill="currentcolor" />
                </svg>
              </div>
              {{ 'Team' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="!isWhyHungeryClicked || !isOnPricingOrWhyHungery">
            <a class="nav-link"
               href="#"
               title="{{ 'Help' | translate }}"
               (click)="removeOverlay(false, true)"
               routerLinkActive="active"
               [ngbTooltip]="'Coming soon'"
               [tooltipClass]="'tooltip-custom'"
               placement="bottom"
               [attr.disabled]="true">
              <div class="svg-wrap">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.8 0H4.2C1.8837 0 0 1.8837 0 4.2V13.3C0 13.4857 0.0737498 13.6637 0.205025 13.795C0.336301 13.9263 0.514348 14 0.7 14H9.8C12.1163 14 14 12.1163 14 9.8V4.2C14 1.8837 12.1163 0 9.8 0ZM7.7 11.2H6.3V9.8H7.7V11.2ZM7.7 8.4H6.3V2.8H7.7V8.4Z"
                        fill="currentcolor" />
                </svg>
              </div>
              {{ 'Help' | translate }}
            </a>
          </li>

          <li class="nav-item" *ngIf="isWhyHungeryClicked && isOnPricingOrWhyHungery">
            <a class="nav-link" aria-current="page" routerLink="/why-hungery" [routerLinkActiveOptions]="{ exact: true }"
               routerLinkActive="active" title="{{ 'Why Hungery' | translate }}" (click)="removeOverlay()">
              {{ 'Why Hungery' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="isWhyHungeryClicked && isOnPricingOrWhyHungery">
            <a class="nav-link" aria-current="page" routerLink="/pricing" [routerLinkActiveOptions]="{ exact: true }"
               routerLinkActive="active" title="{{ 'Pricing' | translate }}" (click)="removeOverlay()">
              {{ 'Pricing' | translate }}
            </a>
          </li>
          <li class="nav-item" *ngIf="isWhyHungeryClicked && isOnPricingOrWhyHungery">
            <a class="nav-link" aria-current="page" [routerLinkActiveOptions]="{ exact: true }"
               routerLinkActive="active" title="{{ 'GetInTouch' | translate }}" (click)="removeOverlay(true)">
              {{ 'GetInTouch' | translate }}
            </a>
          </li>
        </ul>
        <!-- Start here -->
        <!-- <ul class="navbar-nav me-lg-auto" >

        </ul> -->
        <div class="temp-block" [class.temp-nologin-blk]="!isLogin">
          <div ngbDropdown class="language-drop-dv desktop-language-drop-dv">
            <button type="button" class="btn btn-language" id="language" ngbDropdownToggle>
              {{ currentLang | uppercase }} <!-- Show current language here -->
            </button>
            <div ngbDropdownMenu aria-labelledby="language" class="dropdown-menu-lg-end project-dropdown language-dropdown-menu">
              <ul>
                <li><button ngbDropdownItem (click)="changeLanguage('en')">English</button></li>
                <li><button ngbDropdownItem (click)="changeLanguage('id')">Indonesian</button></li>
              </ul>
            </div>
          </div>

          <ul class="action-ul" *ngIf="isLogin">
            <li>
              <app-button [btnText]="''" [btnTitle]="'Message'" [btnCss]="'btn'" [ngbTooltip]="'Coming soon'" [tooltipClass]="'tooltip-custom'" placement="bottom">
                <img src="./assets/images/ic-message.svg" alt="Icon">
              </app-button>
            </li>
            <li>
              <app-button [btnText]="''" [btnTitle]="'Notification'" [btnCss]="'btn'" [ngbTooltip]="'Coming soon'" [tooltipClass]="'tooltip-custom'" placement="bottom">
                <img src="./assets/images/ic-notification.svg" alt="Icon">
              </app-button>
            </li>
          </ul>
          <div class="btn-grps btn-only" *ngIf="!isLogin">


            <!-- [Start] Stop Click event for mobile applciation -->
            <app-button *ngIf="!isFromMobileApp" [id]="'register-btn1'" [btnText]="'Register'" [btnTitle]="'Register'"
                        [btnCss]="'btn btn-text'"
                        (onBtnClick)="openRegisterFromHeader($event)"></app-button>
            <button *ngIf="isFromMobileApp" [id]="'register-btn1'" class="btn btn-text" (click)="openRegisterFromHeader($event)">Register</button>
            <!-- Stop Click event for mobile applciation -->
            <!-- [Start] Stop Click event for mobile applciation -->
            <app-button *ngIf="!isFromMobileApp" [id]="'sign-in-btn1'" [btnText]="'Sign In'" [btnTitle]="'Sign In'"
                        [btnCss]="'btn btn-primary'"
                        (onBtnClick)="openSignInFromHeader($event)"></app-button>
            <button *ngIf="isFromMobileApp" id="sign-in-btn1" class="btn btn-primary" (click)="openSignInFromHeader($event)">Sign In</button>
            <!-- [End] Stop Click event for mobile applciation -->
          </div>
          <div class="btn-grps after-login" *ngIf="isLogin">
            <app-button [btnText]="'Register Business'" [btnTitle]="'Register Business'"
                        [btnCss]="'btn btn-primary-light border-primary btn-register'" [routerLink]="['/onboarding']"
                        *ngIf="business.branchId == 0" (onBtnClick)="removeOverlay();"></app-button>

            <div ngbDropdown class="d-inline-block" *ngIf="business.branchId != 0">
              <button type="button" class="btn btn-business" id="my-business" ngbDropdownToggle>
                My Business
                <img src="./assets/images/ic-arrow-down.svg" alt="Icon" class="arrow">
              </button>
              <div ngbDropdownMenu aria-labelledby="my-business"
                   class="dropdown-menu-lg-end project-dropdown business-dropdown">
                <button ngbDropdownItem [routerLink]="['business-detail',business.branchId]" (click)="removeOverlay();">
                  <img src="./assets/images/menu-option-1.png" alt="Food" class="pre-icon">
                  <div>
                    <h5 class="menu-title">{{business.name}}</h5>
                    <p class="menu-subtitle">{{ business.cuisineName }} {{ business.typeName }}</p>
                  </div>
                  <img src="./assets/images/ic-back.svg" alt="Icon" class="nav-icon">
                </button>
              </div>
            </div>
            <div ngbDropdown class="d-inline-block">
              <button type="button" class="btn btn-user-dropdown" id="userProfileDrop" ngbDropdownToggle>
                <img [src]="profilePictureUrl ? profilePictureUrl : './assets/images/ic-user-default.svg'"
                     alt="User Profile" style="width:41px; height:41px; border-radius: 50%;">
              </button>
              <div ngbDropdownMenu aria-labelledby="userProfileDrop" class="dropdown-menu-end project-dropdown user-profile-dropdown">
                <button ngbDropdownItem title="My Profile" [routerLink]="['/personal-details']"
                        (click)="removeOverlay();">
                  My
                  Profile
                </button>
                <button ngbDropdownItem title="My Articles" [routerLink]="['/articles/my']" *ngIf="allowArticleCreation"
                        (click)="removeOverlay();">
                  My
                  Articles
                </button>
                <button ngbDropdownItem title="Liked Articles" [routerLink]="['/articles/liked']"
                        (click)="removeOverlay()">
                  Liked
                  Articles
                </button>
                <button ngbDropdownItem title="Pre Registration" [routerLink]="['/pre-registration']" *ngIf="allowPreRegistration"
                        (click)="removeOverlay()">
                  Pre Register
                </button>
                <button ngbDropdownItem title="Mass Pre Registration Review" [routerLink]="['/pre-registration-review']" *ngIf="allowPreRegistration"
                        (click)="removeOverlay()">
                  Mass Pre Reg Review
                </button>

                <div ngbDropdown class="language-drop-dv mobile-language-drop-dv">
                  <button type="button" class="btn btn-language" id="language" ngbDropdownToggle>
                    {{ currentLang | uppercase }} <!-- Show current language here -->
                  </button>
                  <div ngbDropdownMenu aria-labelledby="language" class="dropdown-menu-lg-end project-dropdown language-dropdown-menu">
                    <ul>
                      <li><button ngbDropdownItem (click)="changeLanguage('en')">English</button></li>
                      <li><button ngbDropdownItem (click)="changeLanguage('id')">Indonesian</button></li>
                    </ul>
                  </div>
                </div>

                <!-- [Start] Stop Click event for mobile applciation -->
                <button *ngIf="!isFromMobileApp" id="user-log-out-btn" ngbDropdownItem title="Log Out"
                        (click)="onLogOutClick()" (click)="removeOverlay();">
                  Log
                  Out
                </button>
                <button *ngIf="isFromMobileApp" id="user-log-out-btn" ngbDropdownItem title="Log Out"
                        (click)="removeOverlay();">
                  Log
                  Out
                </button>
                <!-- [End] Stop Click event for mobile applciation -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<app-signup #signUpModal (signUpClickEvent)="closeModal($event)" (onCloseBtnClick)="isLoginModalOpen = false"></app-signup>
<app-login #loginModal (onLoginClick)="closeModal($event)" (onCloseBtnClick)="isLoginModalOpen = false"></app-login>
<app-get-in-touch *ngIf="getBtnInvoked" #getInTouchModal (onGetInTouchClick)='closeModal($event)' (updateGetInTouchVariable)="handleUpdate($event)"></app-get-in-touch>
